import { SignIn } from "modules/authentication/pages/sign-in.page";
import { AppCodesPage } from "modules/dashboard/pages/codes/codes.page";
import { Dashboard } from "modules/dashboard/pages/dashboard-home/dashboard.page";
import { ResourceKitPage } from "../modules/dashboard/pages/kitSocialV2/kit.page";
import { AppSalesPage } from "modules/dashboard/pages/sales/sales.page";
import { WithdrawalsPage } from "modules/dashboard/pages/withdrawals/withdrawals.page"; 
import { ReferredPage } from "modules/dashboard/pages/referred/referred.page";
import { ReferredFreeAccountsPage } from "../modules/dashboard/pages/referred-free-accs/referred-free-accs.page";
import { IPFReportsPage } from "../modules/dashboard/pages/ipf-reports/ipf-reports.page";
import { AssociateReportsPage } from "../modules/dashboard/pages/associate-reports/associate-reports.page";

export const routes = [
  {
    key: "sign-in",
    route: "/authentication/sign-in",
    component: SignIn,
  },
  {
    key: "dashboard",
    route: "/dashboard",
    component: Dashboard,
    ibTypesAllowed: [1, 2, 3, 100, 101],
  },
  {
    key: "sells-and-registries",
    route: "/dashboard/sales",
    component: AppSalesPage,
    ibTypesAllowed: [1, 2, 3, 101],
  },
  {
    key: "referred",
    route: "/dashboard/referred",
    component: ReferredPage,
    ibTypesAllowed: [1, 2, 3, 101],
  },
  {
    key: "referred-free-accs",
    route: "/dashboard/referred-free-accs",
    component: ReferredFreeAccountsPage,
    ibTypesAllowed: [1, 2, 3, 101],
  },
  {
    key: "codes",
    route: "/dashboard/codes",
    component: AppCodesPage,
    ibTypesAllowed: [1, 2, 3, 101],
  },
  {
    key: "resources",
    route: "/dashboard/resources",
    component: ResourceKitPage,
    ibTypesAllowed: [1, 2, 3, 101],
  },
  {
    key: "ipf-reports",
    route: "/dashboard/ipf-reports",
    component: IPFReportsPage,
    ibTypesAllowed: [101],
  },
  {
    key: "associate-reports",
    route: "/dashboard/associate-reports",
    component: AssociateReportsPage,
    ibTypesAllowed: [100],
  },
  {
    key: "withdraws",
    route: "/dashboard/withdraws",
    component: WithdrawalsPage,
    ibTypesAllowed: [1, 2, 3, 100, 101],
  },
];
